import { TiTick } from "react-icons/ti";
import { IoClose } from "react-icons/io5";
import { useState, useEffect } from "react";
import TableLoader from "../../../utils/TableLoader";
import PropTypes from 'prop-types';

const UserRoleEdit = (props) => {
  const {
    isLoading,
    roleName,
    userRoleEdit,
    handleCheckboxChange,
    handleSave,
    handleCancel,
  } = props;

  const checkeAllUsersRole = userRoleEdit?.length > 0 ? userRoleEdit?.map((item) => {
    if (item?.actions?.view || item?.actions?.add || item?.actions?.edit || item?.actions?.remove) {
      return item?.module
    }
  }) : []

  const [selectAll, setSelectAll] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [actionChecked, setActionChecked] = useState({
    view: false,
    add: false,
    edit: false,
    remove: false,
  });

  useEffect(() => {
    if (userRoleEdit) {
      const initialRowSelection = {};
      userRoleEdit?.length > 0 && userRoleEdit?.forEach((role) => {
        initialRowSelection[role?.module] = Object.values(role?.actions).every((action) => action);
      });
      setRowSelection(initialRowSelection);
      updateHeaderCheckboxes();
    }
  }, [userRoleEdit]);

  const updateHeaderCheckboxes = () => {
    if (userRoleEdit) {
      const newActionChecked = {
        view: userRoleEdit?.length > 0 && userRoleEdit?.every((role) => role?.actions?.view),
        add: userRoleEdit?.length > 0 && userRoleEdit?.every((role) => role?.actions?.add),
        edit: userRoleEdit?.length > 0 && userRoleEdit?.every((role) => role?.actions?.edit),
        remove: userRoleEdit?.length > 0 && userRoleEdit?.every((role) => role?.actions?.remove),
      };
      setActionChecked(newActionChecked);
      setSelectAll(Object?.values(newActionChecked)?.every((val) => val));
    }
  };

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    const updatedRowSelection = {};
    userRoleEdit?.length > 0 && userRoleEdit?.forEach((role) => {
      updatedRowSelection[role?.module] = isChecked;
      Object.keys(role.actions)?.forEach((action) => {
        handleCheckboxChange(role?.module, action, isChecked);
      });
    });
    setRowSelection(updatedRowSelection);
    setActionChecked({
      view: isChecked,
      add: isChecked,
      edit: isChecked,
      remove: isChecked,
    });
  };

  const handleRowChange = (module, isChecked) => {
    const updatedRowSelection = { ...rowSelection, [module]: isChecked };
    setRowSelection(updatedRowSelection);

    userRoleEdit
      .filter((role) => role?.module === module)
      .forEach((role) => {
        Object.keys(role.actions).forEach((action) => {
          handleCheckboxChange(role?.module, action, isChecked);
        });
      });

    updateHeaderCheckboxes();
  };

  const handleActionChange = (e, actionType) => {
    const isChecked = e.target.checked;
    userRoleEdit?.length > 0 && userRoleEdit?.forEach((role) => {
      handleCheckboxChange(role?.module, actionType, isChecked);
    });
    updateHeaderCheckboxes();
  };

  return (
    <section className="border-t border-[#D9D9D9] sm:mt-5 sm:pt-10 pt-5">
      <h3 className="sm:text-3xl text-xl font-bold mb-2 poppins-medium">
        Modifica Ruoli & Permessi
      </h3>
      <div className="user-roll-table w-auto h-auto bg-[#FCFCFC] border-[2px] border-[#e4d5d7] p-6 mb-6 rounded-2xl shadow">
        <h4 className="mb-2 pb-2 border-b-2 poppins-regular text-[#6B6B6B]">
          Nome Ruolo: <span className="font-semibold text-[#2C2C2C]">{roleName === "Sales Person" ? "Commerciale" : roleName || "N/A"}</span>
        </h4>
        <table className="w-full text-left">
          <thead>
            <tr className="border-b">
              <th className="py-2 font-normal">
                {/* <input
                  type="checkbox"
                  className="h-4 w-4 border rounded-md accent-[#8B2433] mr-5 poppins-regular"
                  checked={selectAll}
                  onChange={handleSelectAllChange}
                /> */}
                Nome Modulo
              </th>
              {["view", "add", "edit", "remove"].map((action) => (
                <th key={action} className="py-1 font-normal">
                  {/* <input
                    type="checkbox"
                    className="h-4 w-4 border rounded-md accent-[#8B2433] mr-5 poppins-regular"
                    checked={actionChecked[action]}
                    onChange={(e) => handleActionChange(e, action)}
                  /> */}
                  {/* {action.charAt(0).toUpperCase() + action.slice(1)} */}
                  {action === "view" ? "Visualizza" :
                    action === "add" ? "Aggiungi" :
                      action === "edit" ? "Modifica" :
                        action === "remove" ? "Elimina" :
                          action.charAt(0).toUpperCase() + action.slice(1)}
                </th>
              ))}
            </tr>
          </thead>
          {isLoading?.edit ? (
            <TableLoader />
          ) : (
            <tbody>
              {userRoleEdit?.length > 0 &&
                userRoleEdit?.map((role) => (
                  <tr key={role?.name} className="border-b">
                    <td>
                      <input
                        type="checkbox"
                        className="h-4 w-4 border rounded-md accent-[#8B2433] mr-5 poppins-regular"
                        checked={checkeAllUsersRole.includes(role?.module) || false}
                        onChange={(e) => handleRowChange(role?.module, e.target.checked)}
                      />
                      <span>
                        {(() => {
                          switch (role?.module) {
                            case "Wines":
                              return "Vini";
                            case "Restaurants":
                              return "Ristoranti";
                            case "WineStock":
                              return "Cantina";
                            case "Orders":
                              return "Ordini";
                            case "WineList":
                              return "Carte Vini";
                            case "Users":
                              return "Utenti";
                            case "Roles":
                              return "Ruoli e permessi";
                            default:
                              return role?.module || "N/A"; // Show original value if not found
                          }
                        })()}
                      </span>
                    </td>
                    {Object.entries(role?.actions).map(([action, value]) => (
                      <td key={action} className="py-5">
                        <input
                          type="checkbox"
                          className="h-4 w-4 border rounded-md accent-[#8B2433]"
                          checked={value}
                          onChange={(e) =>
                            handleCheckboxChange(role?.module, action, e.target.checked)
                          }
                        />
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          )}
        </table>
        <div className="flex text-sm justify-start gap-4 mt-4">
          {isLoading?.save ? (
            <button disabled type="button"
              className="sm:w-[120px] w-full poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-lg transition-colors group">
              <svg
                aria-hidden="true"
                className="w-4 h-4 text-gray-50 me-3 animate-spin dark:text-gray-600 fill-[#8B2433] invert"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              Loading...
            </button>
          ) : (
            <button className="sm:w-[120px] w-full flex items-center justify-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
              onClick={handleSave}
            >
              <TiTick size={"25px"} color="green" />
              <span className="poppins-regular">Salva</span>
            </button>
          )}
          <button
            className="sm:w-[120px] w-full flex items-center space-x-2 p-1 px-3 justify-center bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
            onClick={handleCancel}
          >
            <IoClose size={"25px"} color="red" className="group-hover:invert" />
            <span className="poppins-regular">Annulla</span>
          </button>
        </div>
      </div>
    </section>
  );
};

UserRoleEdit.propTypes = {
  isLoading: PropTypes.shape({
    edit: PropTypes.bool,
    save: PropTypes.bool,
  }).isRequired,
  roleName: PropTypes.string,
  userRoleEdit: PropTypes.arrayOf(
    PropTypes.shape({
      module: PropTypes.string.isRequired,
      actions: PropTypes.shape({
        view: PropTypes.bool.isRequired,
        add: PropTypes.bool.isRequired,
        edit: PropTypes.bool.isRequired,
        remove: PropTypes.bool.isRequired,
      }).isRequired,
    })
  ).isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
};

export default UserRoleEdit;
